

import React, { Suspense } from "react";

const Pie = React.lazy(() =>
  import("@ant-design/plots").then(module => ({ default: module.Pie }))
);

const PieChart = ({ config }) => {
  return (
    <Suspense fallback={<div>Loading chart...</div>}>
      <Pie {...config} />
    </Suspense>
  );
};

export default PieChart;
